import { IClientBusinessModel } from '../../../../../../../Types/ClientModelTypes';
import { DisabledType } from '../../BusinessDataForm/Utils/BusinessDataFormUtils';
import { IconType } from '../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

export enum BusinessCollectionMenuItem {
  Add = 'Add',
  Columns = 'Columns',
  Urval = 'Urval',
  Refetch = 'Refetch',
  ExportExcel = 'ExportExcel',
  Legend = 'Legend',
}

export interface IBusinessCollectionMenuItemParams {
  collection: IClientBusinessModel;
  onAddClick: () => void;
  onColumnsClick: () => void;
  onUrvalClick: () => void;
  onRefetchClick: () => void;
  onExportExcelClick: () => void;
  onLegendClick: () => void;
}
export interface IBusinessCollectionMenuItem {
  id: string;
  label: string | ((params: IBusinessCollectionMenuItemParams) => string);
  onClick: (params: IBusinessCollectionMenuItemParams) => void;
  isDisabled?:
    | boolean
    | ((params: IBusinessCollectionMenuItemParams) => DisabledType);
  isHidden?: boolean | ((params: IBusinessCollectionMenuItemParams) => boolean);
  iconType?: IconType;
}

export type BusinessCollectionMenuItemHookType =
  () => IBusinessCollectionMenuItem;

export type BusinessCollectionMenuItemsType = Array<
  IBusinessCollectionMenuItem | BusinessCollectionMenuItemHookType
>;

export const defaultBusinessCollectionMenuItem: {
  [key in BusinessCollectionMenuItem]: IBusinessCollectionMenuItem;
} = {
  Add: {
    id: BusinessCollectionMenuItem.Add,
    label: params => `Lägg till ${params.collection.RootType.SOLabel}`,
    onClick: params => {
      params.onAddClick();
    },
    iconType: 'add',
  },
  Urval: {
    id: BusinessCollectionMenuItem.Urval,
    label: 'Urval',
    onClick: params => {
      params.onUrvalClick();
    },
    iconType: 'filter_list',
  },
  Columns: {
    id: BusinessCollectionMenuItem.Columns,
    label: 'Kolumner och visningstyp',
    onClick: params => {
      params.onColumnsClick();
    },
    iconType: 'view_column',
  },
  Refetch: {
    id: BusinessCollectionMenuItem.Refetch,
    label: 'Uppdatera',
    onClick: params => {
      params.onRefetchClick();
    },
    iconType: 'refresh',
  },
  ExportExcel: {
    id: BusinessCollectionMenuItem.ExportExcel,
    label: 'Exportera till Excel',
    onClick: params => {
      params.onExportExcelClick();
    },
    iconType: 'excel_export',
  },
  Legend: {
    id: BusinessCollectionMenuItem.Legend,
    label: 'Visa färger och betydelser',
    onClick: params => {
      params.onLegendClick();
    },
    iconType: 'legend_active',
  },
};

export const allDefaultBusinessCollectionMenuItem: IBusinessCollectionMenuItem[] =
  [
    defaultBusinessCollectionMenuItem.Add,
    defaultBusinessCollectionMenuItem.Urval,
    defaultBusinessCollectionMenuItem.Columns,
    defaultBusinessCollectionMenuItem.Refetch,
    defaultBusinessCollectionMenuItem.ExportExcel,
    defaultBusinessCollectionMenuItem.Legend,
  ];
